import type { AllRouteEndpoints } from "../routeTypes";
export const postIntegrationsDirectCdiSourcesSourceIdTestConnectionCacheKeys: AllRouteEndpoints[] = [
  "/integrations/direct/cdi/sources",
];
